const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/regions/$regionId/$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated/_feature_announcement/regions/$regionId/$")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/*
 * This component handles the legacy network routing for event routes.
 * Instead of having to fetch the legacy ID of a group or region whenever we
 * want to link to an event, instead we can simply use this route to redirect
 * pages from /event/$eventId/$routePath to /(groups|regions)/($groupId|$regionId)/events/$eventId/$routePath,
 * so that all you have to do to link to an event is to link to /events/$eventId/$routePath.
 *
 * This uses the splat/catch-all route in TanStack ($), which we use to pass in
 * the routePath we want to go to after the redirect (ex, /events/$eventId/manage/attendees).
 * https://tanstack.com/router/v1/docs/framework/react/routing/routing-concepts#splat--catch-all-routes
 *
 * We can then access that _splat route from the useParams hook, and append it to
 * the route we're redirecting to.
 *
 * Example usage:
 *
 * to: "/events/$eventId/$",
 * params: {
 *  eventId,
 *  _splat: "/manage/attendees",
 * },
 *
 * Note that _splat can also capture everything after the base route (in this case, "/manage/attendees")
 * without having to specify it in the params object (ex. to: "/events/$eventId/manage/attendees"),
 * but this causes type errors.
 * Directly assigning _splat in the params object and then appending it to the route
 * in here avoids this issue, but does mean that providing an invalid route to
 * the _splat prop will redirect you to a not found page without a type error.
 */